import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useFeatures } from "../contexts/FeaturesContext";

export default function CentroControlloEvolutoPage() {
  const { isOrgAdmin, isPlatformOwner } = useAuth();
  const { hasFeature, orgPlan, PLANS } = useFeatures();
  const isAdmin = isPlatformOwner || isOrgAdmin;
  const unlocked = hasFeature("kpi") && hasFeature("centroClienti");

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{background:"#fff",borderBottom:"1px solid #e5e7eb",padding:"14px 24px",flexShrink:0}}>
        <h2 style={{fontSize:18,fontWeight:700,display:"flex",alignItems:"center",gap:8}}>
          <span>📈</span> Centro Controllo Evoluto
        </h2>
      </div>

      <div style={{flex:1,overflowY:"auto",padding:40,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <div style={{maxWidth:600,textAlign:"center"}}>

          {/* Hero */}
          <div style={{background:"linear-gradient(135deg,#0891b2,#7c3aed)",borderRadius:20,padding:36,marginBottom:32,position:"relative",overflow:"hidden"}}>
            <div style={{fontSize:48,marginBottom:12}}>📈</div>
            <div style={{fontSize:22,fontWeight:800,color:"#fff",marginBottom:8}}>Statistiche avanzate per cliente</div>
            <div style={{fontSize:14,color:"rgba(255,255,255,0.85)",lineHeight:1.6,maxWidth:420,margin:"0 auto"}}>
              Trasforma i dati delle tue commesse in intelligence di business: scopri quali clienti generano più valore, dove concentrare gli sforzi commerciali e come sta crescendo il tuo portafoglio.
            </div>
            <div style={{position:"absolute",top:-30,right:-30,width:120,height:120,borderRadius:"50%",background:"rgba(255,255,255,0.08)"}}/>
            <div style={{position:"absolute",bottom:-40,left:-20,width:160,height:160,borderRadius:"50%",background:"rgba(255,255,255,0.05)"}}/>
          </div>

          {/* Anteprima funzionalità bloccate */}
          <div style={{textAlign:"left",marginBottom:32}}>
            <div style={{fontSize:16,fontWeight:700,color:"#111827",marginBottom:16}}>Cosa include il Centro Controllo Evoluto:</div>
            {[
              { icon:"📊", title:"Statistiche per cliente", desc:"Numero commesse, valore totale, tasso di completamento e tempo medio di chiusura per ogni cliente." },
              { icon:"🗂️", title:"Aggregazione commesse", desc:"Vedi tutte le commesse di un cliente raggruppate, con stato e andamento nel tempo." },
              { icon:"📈", title:"Dashboard analitiche", desc:"Grafici di crescita, distribuzione del fatturato per cliente e settore, trend mensili." },
              { icon:"🕒", title:"Storico lavori", desc:"Cronologia completa di ogni intervento e commessa associata al cliente, sempre consultabile." },
              { icon:"🎯", title:"KPI di portafoglio clienti", desc:"Identifica i clienti più redditizi e quelli a rischio inattività, per guidare le decisioni commerciali." },
            ].map((f,i) => (
              <div key={i} style={{display:"flex",gap:14,padding:"14px 0",borderBottom:"1px solid #f3f4f6", opacity: unlocked ? 1 : 0.85}}>
                <div style={{fontSize:24,flexShrink:0}}>{f.icon}</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:600,color:"#111827",marginBottom:3,display:"flex",alignItems:"center",gap:8}}>
                    {f.title}
                    {!unlocked && <span style={{fontSize:10,fontWeight:700,color:"#9ca3af",background:"#f3f4f6",padding:"1px 6px",borderRadius:10}}>🔒 PREMIUM</span>}
                  </div>
                  <div style={{fontSize:13,color:"#6b7280",lineHeight:1.5}}>{f.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {unlocked ? (
            <div style={{background:"#d1fae5",border:"1px solid #6ee7b7",borderRadius:12,padding:20,textAlign:"center"}}>
              <div style={{fontSize:14,fontWeight:700,color:"#059669",marginBottom:8}}>✓ Funzionalità sbloccata sul tuo piano</div>
              <div style={{fontSize:13,color:"#065f46"}}>Visita la sezione "Clienti" per consultare statistiche e KPI per ogni cliente.</div>
            </div>
          ) : (
            <div style={{background:"#f9fafb",border:"1px solid #e5e7eb",borderRadius:12,padding:20,marginBottom:8}}>
              <div style={{fontSize:13,color:"#6b7280",marginBottom:4}}>Piano attuale</div>
              <div style={{fontSize:18,fontWeight:700,color:"#111827",marginBottom:12}}>
                {PLANS[orgPlan]?.label || "Free"} — {PLANS[orgPlan]?.price || "Gratuito"}
              </div>
              <div style={{fontSize:13,color:"#374151",lineHeight:1.6,marginBottom:16}}>
                Il Centro Controllo Evoluto è una funzionalità <strong style={{color:"#7c3aed"}}>Premium</strong>, disponibile a partire dal piano Pro.
                I tuoi dati cliente sono già pronti — basta passare di piano per sbloccare le statistiche, senza nessuna migrazione o perdita di dati.
              </div>
              <div style={{display:"flex",gap:10,justifyContent:"center"}}>
                <button style={{padding:"10px 24px",background:"#7c3aed",color:"#fff",border:"none",borderRadius:10,fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
                  Passa al piano Pro →
                </button>
                {isAdmin && (
                  <button style={{padding:"10px 24px",background:"#fff",color:"#374151",border:"1px solid #e5e7eb",borderRadius:10,fontSize:14,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
                    Contatta il supporto
                  </button>
                )}
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
